var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Interactions (Live)")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying Live Interactions")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [(_vm.userAccessLevel != "agent") ? _c('div', [(!_vm.paused) ? _c('b-btn', {
    staticClass: "pull-right ml-1",
    attrs: {
      "type": "button",
      "variant": "danger",
      "disabled": _vm.loadingPause
    },
    on: {
      "click": _vm.bossPause
    }
  }, [_c('i', {
    staticClass: "fa fa-pause"
  }), _vm._v("  Pause Autoreply")]) : _vm._e(), (_vm.paused) ? _c('b-btn', {
    staticClass: "pull-right ml-1",
    attrs: {
      "type": "button",
      "variant": "success",
      "disabled": _vm.loadingPause
    },
    on: {
      "click": _vm.bossPause
    }
  }, [_c('i', {
    staticClass: "fa fa-play"
  }), _vm._v("  Resume Autoreply")]) : _vm._e()], 1) : _vm._e()])]), _c('br'), (_vm.loading) ? _c('div', [_vm._v(_vm._s(_vm.loadingText))]) : _c('div', [(_vm.tableItemsFlag.length > 0) ? _c('div', [_c('app-interactionsTable', {
    attrs: {
      "data": _vm.tableItemsFlag,
      "label": _vm.tableFieldsFlag,
      "rowClick": "rowClick"
    }
  }), _c('br')], 1) : _vm._e(), (!_vm.boss) ? _c('app-interactionsTable', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields,
      "rowClick": "rowClick"
    }
  }) : _vm._e()], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d79130e","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/InteractionsRT.vue
// module id = 904
// module chunks = 1